import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { configOperations } from '../../../redux/config';
import { mapOperations } from '../../../redux/map';

import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Select from '@material-ui/core/Select';
import TextField from '@mui/material/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import RequiredFieldStatus from '../RequiredFieldStatus';

import originFields from '../../../defaults/PointOfOriginFields.json'
import fireCauseConfig from '../../../defaults/fireCauseConfig.json'
import '../DetailsIncidentPanel.css';

class FireCausePanel extends Component {
  constructor(props) {

    super(props);
    this.state = {
      open: true,
      highlightRequiredFields: false,
      primaryRequiredNullFields: [],
      requiredNullFields: [],
      derivingFields: [],
      secondaryRequiredNullFields: [],
      totalRequiredNullFields: null,
      requiredFields: props.requiredFields ? props.requiredFields : [],
      staticFields: props.staticFields ? props.staticFields : [],
      attributes: props.attributes,
      dependentFields: props.dependentFields ? props.dependentFields : [],
      fireCauseDisabled: false,
      ageCategoryDisabled: false,
      specificCauseDetailsDisabled: false,
      prohibitedCheckboxDisabled: false,
      activityGroupsDisabled: false
    };
  }

  componentDidMount() {
    this.updateRequiredNullFields(this.props.attributes, this.state.requiredFields);
  }

  //TODO: Try to get rid of all componentWillReceiveProps
  componentWillReceiveProps(nextProps) {

    if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields === 0) {
      this.setState({
        open: false
      });
    }

    if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields > 0) {
      this.setState({
        open: true
      });
    }

    if (nextProps.expandAllPanels === true) {
      this.setState({
        open: true
      });
    }


    if (nextProps.requiredFields && this.props.requiredFields) {
      if (JSON.stringify({ ...nextProps.requiredFields }) !== JSON.stringify({ ...this.state.requiredFields })) {
        this.updateRequiredFields(nextProps.requiredFields);

        if (nextProps.attributes && this.props.attributes) {
          this.updateRequiredNullFields(nextProps.attributes, nextProps.requiredFields);
        }
      }
    }

    if (nextProps.attributes && this.props.attributes) {
      if (JSON.stringify({ ...nextProps.attributes }) !== JSON.stringify({ ...this.props.attributes })) {
        this.updateRequiredNullFields(nextProps.attributes, nextProps.requiredFields);
      }

      if (nextProps.attributes.FireCauseGeneralID !== this.props.attributes.FireCauseGeneralID) {
        this.configureFireCauseStates(nextProps.attributes.FireCauseID, nextProps.attributes.FireCauseGeneralID);
      }
    }
  }

  configureFireCauseStates = (fireCauseId, fireCauseGeneralId) => {
    const fireCause = fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === fireCauseId);
    const fireCauseGeneral = (fireCause) ? fireCause.GeneralFireCauses.find(causeGeneral => causeGeneral.CauseGeneralID === fireCauseGeneralId) : null;

    const ageCategoryDisabled = (fireCauseGeneral) ? fireCauseGeneral.AgeCategoryDisabled : false;
    const specificCauseDetailsDisabled = (fireCauseGeneral) ? fireCauseGeneral.SpecificCauseDetailsDisabled : false;
    const prohibitedCheckboxDisabled = (fireCauseGeneral) ? fireCauseGeneral.ProhibitedCheckboxDisabled : false;
    const activityGroupsDisabled = (fireCauseGeneral) ? fireCauseGeneral.ActivityGroupsDisabled : false;

    this.setState({
      ageCategoryDisabled: ageCategoryDisabled,
      specificCauseDetailsDisabled: specificCauseDetailsDisabled,
      prohibitedCheckboxDisabled: prohibitedCheckboxDisabled,
      activityGroupsDisabled: activityGroupsDisabled
    });
  }

  updateRequiredFields = (updatedRequiredFields) => {
    this.setState({
      requiredFields: updatedRequiredFields
    });
  }

  updateRequiredNullFields = (attributes, requiredFields) => {

    if (!requiredFields) {
      return;
    }
    if (!attributes) {
      console.warn('missing argument');
      return;
    }

    let missingFields = [];

    const fireCauseFields = [
      originFields.fireCauseId,
      originFields.fireCauseGeneralId,
      originFields.fireCauseSpecificId,
      originFields.fireCauseSpecificDetailID,
      originFields.fireCauseAgeCategoryID,
      originFields.fireCauseActivityGroupID,
      originFields.fireCauseComments,
      originFields.isCauseProhibited,
      originFields.isFireCauseInvestigated,
      originFields.isTrespass
    ];

    fireCauseFields.forEach(field => {
      const fieldVal = attributes[field];
      if (requiredFields.includes(field) && (fieldVal === undefined || fieldVal === null)) {
        missingFields.push(field);
      }
    });

    this.setState({
      totalRequiredNullFields: missingFields.length
    }) ;

  }

  getFireCauseGeneralOptions = () => {
    if (this.props.attributes.FireCauseID) {
      const fireCause = fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === this.props.attributes.FireCauseID);
      return fireCause.GeneralFireCauses.map(cause => {
        return <MenuItem key={cause.CauseGeneralID} value={cause.CauseGeneralID}>{cause.CauseGeneral} </MenuItem>
      });
    }
  }

  getSpecificCauseDetails = () => {
    if (this.props.attributes.FireCauseGeneralID) {
      const fireCause = fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === this.props.attributes.FireCauseID);
      const fireCauseGeneral = fireCause.GeneralFireCauses.find(causeGeneral => causeGeneral.CauseGeneralID === this.props.attributes.FireCauseGeneralID);

      if (fireCauseGeneral && fireCauseGeneral.SpecificDetailFireCauses) 
      {
        return fireCauseGeneral.SpecificDetailFireCauses.map(causeSpecificDetail => {
        return <MenuItem key={causeSpecificDetail.SpecificDetailID} value={causeSpecificDetail.SpecificDetailID}>{causeSpecificDetail.SpecificDetail}</MenuItem>
      });
    }
    }
  }

  getFireCauseSpecificOptions = () => 
  {
    if (this.props.attributes.FireCauseGeneralID) 
    {
      const fireCause = fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === this.props.attributes.FireCauseID);
      const fireCauseGeneral = fireCause.GeneralFireCauses.find(causeGeneral => causeGeneral.CauseGeneralID === this.props.attributes.FireCauseGeneralID);

      if (fireCauseGeneral && fireCauseGeneral.SpecificFireCauses) 
      {
        return fireCauseGeneral.SpecificFireCauses.map(causeSpecific => {
          return <MenuItem key={causeSpecific.CauseSpecificID} value={causeSpecific.CauseSpecificID}>{causeSpecific.CauseSpecific}</MenuItem>
        });
      }
    }
  }


  getCauseActivityGroups = () => {

    if (this.props.attributes.FireCauseGeneralID) {
      const fireCause = fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === this.props.attributes.FireCauseID);
      const fireCauseGeneral = fireCause.GeneralFireCauses.find(causeGeneral => causeGeneral.CauseGeneralID === this.props.attributes.FireCauseGeneralID);

      if (fireCauseGeneral && fireCauseGeneral.CauseActivityGroups) 
      {
        return fireCauseGeneral.CauseActivityGroups.map(causeActivity => {
        return <MenuItem key={causeActivity.ActivityGroupID} value={causeActivity.ActivityGroupID}>{causeActivity.ActivityGroup}</MenuItem>
      });
    }

    }
  }

  getAgeCategories = () => {

    if (this.props.attributes.FireCauseGeneralID) {
      const fireCause = fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === this.props.attributes.FireCauseID);
      const fireCauseGeneral = fireCause.GeneralFireCauses.find(causeGeneral => causeGeneral.CauseGeneralID === this.props.attributes.FireCauseGeneralID);
      if (fireCauseGeneral && fireCauseGeneral.AgeCategories) 
      {
      return fireCauseGeneral.AgeCategories.map(ageCategory => {
        return <MenuItem key={ageCategory.AgeCategoryID} value={ageCategory.AgeCategoryID}>{ageCategory.AgeCategory} </MenuItem>
      });
      }
    }
  }

  updateGeneralProp = (field, val) => {
    const fireCause = fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === this.props.attributes.FireCauseID);
    const fireCauseGeneral = fireCause.GeneralFireCauses.find(causeGeneral => causeGeneral.CauseGeneralID === val);

    const ageCategoryDisabled = (fireCauseGeneral) ? fireCauseGeneral.AgeCategoryDisabled : false;
    const specificCauseDetailsDisabled = (fireCauseGeneral) ? fireCauseGeneral.SpecificCauseDetailsDisabled : false;
    const prohibitedCheckboxDisabled = (fireCauseGeneral) ? fireCauseGeneral.ProhibitedCheckboxDisabled : false;
    const activityGroupsDisabled = (fireCauseGeneral) ? fireCauseGeneral.ActivityGroupsDisabled : false;

    this.setState({
      ageCategoryDisabled: ageCategoryDisabled,
      specificCauseDetailsDisabled: specificCauseDetailsDisabled,
      prohibitedCheckboxDisabled: prohibitedCheckboxDisabled,
      activityGroupsDisabled: activityGroupsDisabled
    });

    this.props.onPropUpdated(originFields.fireCauseGeneralId, val);
  }

  highlightRequiredFields = () => {
    const open = this.state.open || (this.state.secondaryRequiredNullFields.length > 0);
    this.setState({
      open,
      highlightRequiredFields: true
    }, () => {
      window.setTimeout(() => {
        this.setState({ highlightRequiredFields: false })
      }, 1000);
    });
  }

  const 
  accordionChange = (event) => {
    this.setState({ open: !this.state.open });
    this.props.resetPanelCollapseFlag();
  }

  render() { 
    const causeRequired = (this.props.requiredFields.includes(originFields.fireCauseId));
    const causeGeneralRequired = (this.props.requiredFields.includes(originFields.fireCauseGeneralId));
    const causeRequiredAndMissing = (causeRequired && (!this.props.attributes.FireCauseID));
    const causeGeneralRequiredAndMissing = (causeGeneralRequired && (!this.props.attributes.FireCauseGeneralID));
    const causeHighlight = (causeRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";
    const causeGeneralHighlight = (causeGeneralRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";

    const specificRequired = (this.props.requiredFields.includes(originFields.fireCauseSpecificId));
    const specificDetailRequired = (this.props.requiredFields.includes(originFields.fireCauseSpecificDetailID));
    const specificRequiredAndMissing = (specificRequired && (!this.props.attributes.FireCauseSpecificID));
    const specificDetailRequiredAndMissing = (specificDetailRequired && (!this.props.attributes.FireCauseSpecificDetailID));
    const specificHighlight = (specificRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";
    const specificDetailHighlight = (specificDetailRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";

    const activityGroupRequired = (this.props.requiredFields.includes(originFields.fireCauseActivityGroupID));
    const ageCategoryRequired = (this.props.requiredFields.includes(originFields.fireCauseAgeCategoryID));
    const activityGroupRequiredAndMissing = (activityGroupRequired && (!this.props.attributes.FireCauseActivityGroupID));
    const ageCategoryRequiredAndMissing = (ageCategoryRequired && (!this.props.attributes.FireCauseAgeCategoryID));
    const activityGroupHighlight = (activityGroupRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";
    const ageCategoryHighlight = (ageCategoryRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";

    const causeCommentsRequired = (this.props.requiredFields.includes(originFields.fireCauseComments));
    const causeCommentsRequiredAndMissing = (causeCommentsRequired && (!this.props.attributes.FireCauseComments));
    const causeCommentsHighlight = (causeCommentsRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";

    const isCauseProhibitedRequired = (this.props.requiredFields.includes(originFields.isCauseProhibited));
    const isCauseProhibitedRequiredAndMissing = (isCauseProhibitedRequired && (!this.props.attributes.IsCauseProhibited));
    const isCauseProhibitedHighlight = (isCauseProhibitedRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";

    const causeInvestigatedRequired = (this.props.requiredFields.includes(originFields.isFireCauseInvestigated));
    const causeInvestigatedRequiredAndMissing = (causeInvestigatedRequired && (!this.props.attributes.IsFireCauseInvestigated));
    const causeInvestigatedHighlight = (causeInvestigatedRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";

    const isTrespassRequired = (this.props.requiredFields.includes(originFields.isTrespass));
    const isTrespassRequiredAndMissing = (isTrespassRequired && (!this.props.attributes.IsTrespass));
    const isTrespassHighlight = (isTrespassRequiredAndMissing && this.props.highlightRequiredFields) ? " detail-row-highlight-field" : "";

    const renderLabel = (text, isRequired) => (
    <label className={`detail-row-label${isRequired ? ' detail-row-required' : ''}`}>
      {isRequired ? (
        <span>
          {text}
          <span className="required-symbol">*</span>
        </span>
      ) : (
        text
      )}
    </label>
  );

    // Usage
    const fireCauseLabel = renderLabel("Fire Cause", causeRequired);
    const fireCauseGeneralLabel = renderLabel("Fire Cause General", causeGeneralRequired);
    const specificLabel = renderLabel("Fire Cause Specific", specificRequired);
    const specificDetailLabel = renderLabel("Specific Detail", specificDetailRequired);
    const activityGroupLabel = renderLabel("Activity / Group", activityGroupRequired);
    const ageCategoryLabel = renderLabel("Age Category", ageCategoryRequired);
    const causeCommentsLabel = renderLabel("Cause Comments", causeCommentsRequired);
    const isCauseProhibitedLabel = renderLabel("Cause Prohibited?", isCauseProhibitedRequired);
    const causeInvestigatedLabel = renderLabel("Cause Investigated?", causeInvestigatedRequired);
    const trespassLabel = renderLabel("Is Trespass?", isTrespassRequired);


    let requiredFieldStatusNode = '';
    if (this.state.totalRequiredNullFields > 0) {
      requiredFieldStatusNode = (
        <RequiredFieldStatus
          chipClicked={this.highlightRequiredFields}
          missingFields={this.state.totalRequiredNullFields} />
      )
    }

    let title = (
      <div className="incident-details-panel-header">
        <h4>{this.props.title}</h4>
        <span className="required-field-node-class">{requiredFieldStatusNode}</span>
      </div>
    )

    //Deal with highlightFieldClass

    return (
      <Accordion className="incident-details-panel" expanded={this.state.open} onChange={this.accordionChange}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</AccordionSummary>
        <AccordionDetails>
          <div className="incident-details-panel-expander">

            <div className={"detail-row" + causeHighlight}>
              {fireCauseLabel}
              <div className="detail-row-value">
                <Select
                  disabled={this.props.mode === "read"}
                  value={(this.props.attributes.FireCauseID) ? this.props.attributes.FireCauseID : ""}
                  onChange={(event) => {
                    this.props.onPropUpdated(originFields.fireCauseId, (event.target.value) ? event.target.value : null);
                  }}>
                  {fireCauseConfig.FireCauses.map(cause => {
                    return <MenuItem key={cause.FireCauseID} value={cause.FireCauseID}>{cause.FireCauseName}</MenuItem>
                  })}
                </Select>
              </div>
            </div>

            <div className={"detail-row" + causeGeneralHighlight}>
              {fireCauseGeneralLabel}
              <div className="detail-row-value">
                <Select
                  fullWidth={true} autoWidth={true} disabled={this.props.mode === "read"}
                  value={(this.props.attributes.FireCauseGeneralID) ? this.props.attributes.FireCauseGeneralID : ""}
                  onChange={(event) => {
                    this.updateGeneralProp(originFields.fireCauseGeneralId, (event.target.value) ? event.target.value : null)
                  }}>
                  {this.getFireCauseGeneralOptions()}
                </Select>
              </div>
            </div>

            <div className={"detail-row" + specificHighlight}>
              {specificLabel}
              <div className="detail-row-value">
                <Select
                  fullWidth={true} autoWidth={true} disabled={this.props.mode === "read"}
                  value={(this.props.attributes.FireCauseSpecificID) ? this.props.attributes.FireCauseSpecificID : ""}
                  onChange={(event) => {
                    this.props.onPropUpdated(originFields.fireCauseSpecificId, (event.target.value) ? event.target.value : null);
                  }}>
                  {this.getFireCauseSpecificOptions()}
                </Select>
              </div>
            </div>

            <div className={"detail-row" + specificDetailHighlight}>
            {specificDetailLabel}
              <div className="detail-row-value">
                <Select
                  fullWidth={true} autoWidth={true} disabled={this.props.mode === "read" || this.state.specificCauseDetailsDisabled}
                  value={this.props.attributes.FireCauseSpecificDetailID}
                  onChange={(event) => {
                    this.props.onPropUpdated(originFields.fireCauseSpecificDetailID, (event.target.value) ? event.target.value : null);
                  }}>
                  {this.getSpecificCauseDetails()}
                </Select>
              </div>
            </div>

            <div className={"detail-row" + activityGroupHighlight}>
            {activityGroupLabel}
              <div className="detail-row-value">
                <Select
                  fullWidth={true} autoWidth={true} disabled={this.props.mode === "read" || this.state.activityGroupsDisabled}
                  value={this.props.attributes.FireCauseActivityGroupID}
                  onChange={(event) => {
                    this.props.onPropUpdated(originFields.fireCauseActivityGroupID, (event.target.value) ? event.target.value : null);
                  }}>
                  {this.getCauseActivityGroups()}
                </Select>
              </div>
            </div>

            <div className={"detail-row" + ageCategoryHighlight}>
            {ageCategoryLabel}
              <div className="detail-row-value">
                <Select
                  fullWidth={true} autoWidth={true} disabled={this.props.mode === "read" || this.state.ageCategoryDisabled}
                  value={this.props.attributes.FireCauseAgeCategoryID}
                  onChange={(event) => {
                    this.props.onPropUpdated(originFields.fireCauseAgeCategoryID, (event.target.value) ? event.target.value : null);
                  }}>
                  {this.getAgeCategories()}
                </Select>

              </div>
            </div>

            <div  className={"detail-row" + isCauseProhibitedHighlight}>
            {isCauseProhibitedLabel}
              <div className="detail-row-value">
              <FormControl>
                <RadioGroup
                  row
                  disabled={this.props.mode === "read" || this.state.prohibitedCheckboxDisabled}
                  name="row-radio-buttons-group"
                  onChange={(event) => 
                    {
                    this.props.onPropUpdated(originFields.isCauseProhibited, event.target.value );
                  }}
                  value={this.props.attributes.IsCauseProhibited}>
                  <FormControlLabel disabled={this.props.mode === "read" || this.state.prohibitedCheckboxDisabled} value={1} control={<Radio />} label="Yes" />
                  <FormControlLabel disabled={this.props.mode === "read" || this.state.prohibitedCheckboxDisabled} value={0} control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
              </div>
            </div>


            <div className={"detail-row" + causeCommentsHighlight}>
            {causeCommentsLabel}
              <div className="detail-row-value">
                <TextField
                value={this.props.attributes.FireCauseComments || ""}
                multiline
                maxRows={5}
                disabled={this.props.mode === "read"}
                onChange={(event) => {
                  this.props.onPropUpdated(
                    originFields.fireCauseComments,
                    event.target.value || null
                  );
                }}
              />
              </div>
            </div>
          
            <div className={"detail-row" + causeInvestigatedHighlight}>
              {causeInvestigatedLabel}
              <div className="detail-row-value">
              <FormControl>
                <RadioGroup
                  row
                  disabled={this.props.mode === "read"}
                  name="row-radio-buttons-group"
                  onChange={(event) => 
                    {
                    this.props.onPropUpdated(originFields.isFireCauseInvestigated, event.target.value);
                  }}
                  value={this.props.attributes[originFields.isFireCauseInvestigated]}>
                  <FormControlLabel disabled={this.props.mode === "read" } value={1} control={<Radio />} label="Yes" />
                  <FormControlLabel disabled={this.props.mode === "read" } value={0} control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
              </div>
            </div>

            <div className={"detail-row" + isTrespassHighlight}>
              {trespassLabel}
              <div className="detail-row-value">
              <FormControl>
                <RadioGroup
                  row
                  disabled={this.props.mode === "read"}
                  name="row-radio-buttons-group"
                  onChange={(event) => 
                    {
                    this.props.onPropUpdated(originFields.isTrespass, event.target.value);
                  }}
                  value={this.props.attributes[originFields.isTrespass]}>
                  <FormControlLabel disabled={this.props.mode === "read" } value={1} control={<Radio />} label="Yes" />
                  <FormControlLabel disabled={this.props.mode === "read" } value={0} control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
              </div>
            </div>

          </div>
        </AccordionDetails>
      </Accordion>
    );
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  map: state.map
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...configOperations,
    ...mapOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FireCausePanel)
